var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 10.052A8.045 8.045 0 1 0 8.846 18v-6.138h-2.02V9.448h2.02V7.654c0-2.083 1.223-3.218 3.017-3.218.602 0 1.204.033 1.802.097v2.18h-1.239c-.973 0-1.158.459-1.158 1.183v1.552h2.349l-.306 2.414H11.3V18a8.045 8.045 0 0 0 6.79-7.948Z",
    fill: "currentColor"
  })));
};

export default SvgFacebook;